exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.cardTextPadding0 > .v-card__text {\n    padding: 0 !important;\n}\n.cardTextPadding2 > .v-card__text {\n    padding: 8px !important;\n}\n\n", ""]);
